// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".price-format[data-v-625e4220] {\n  color: #c03131;\n  margin-left: -1px;\n}\n", ""]);
// Exports
module.exports = exports;
